<div class="overflow-auto">
  <div
    class="rounded-3xl border-2 border-primary-100 w-full flex flex-col overflow-hidden"
  >
    <div
      class="text-center flex flex-col text-slate-800 text-lg font-medium tracking-tight"
    >
      <div
        class="text-slate-800 text-xl text-center leading-normal flex items-center justify-between p-10 pr-4"
      >
        <div class="font-medium shrink-0 basis-2/3 lg:basis-2/5 text-left">
          Recursos / Features
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 font-medium text-gray-500">
          Starter
        </div>
        <div
          class="shrink-0 basis-1/2 lg:basis-1/5 font-medium text-primary-500"
        >
          Pro
        </div>
        <div
          class="shrink-0 basis-1/2 lg:basis-1/5 font-medium text-secondary-700"
        >
          Premium
        </div>
      </div>
      <div class="flex items-center justify-between p-4 lg:pl-10 bg-slate-100">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          <div class="flex flex-col">Mobo Delivery</div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between p-4 lg:pl-10">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          Isenção de comissão por cupom
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between p-4 lg:pl-10 bg-slate-100">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          Gerenciador de campanhas
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between p-4 lg:pl-10">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          Campanhas simultâneas diariamente
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">3</div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">até 10</div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div>Ilimitado</div>
        </div>
      </div>
      <div class="flex items-center justify-between p-4 lg:pl-10 bg-slate-100">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          Desconto mínimo da campanha
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">15%</div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">15%</div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="text-success-500">10%</div>
        </div>
      </div>
      <!-- <div class="flex items-center justify-between p-4 lg:pl-10 bg-slate-100">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          Pontos de Venda (mesma marca)
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">1</div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">até 3</div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="text-success-500">até 6</div>
        </div>
      </div> -->
      <div class="flex items-center justify-between p-4 lg:pl-10">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          Usuários no Painel Administrador
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">2</div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">até 6</div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="text-success-500">até 12</div>
        </div>
      </div>
      <div class="flex items-center justify-between p-4 lg:pl-10 bg-slate-100">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          Plataforma Online, Relatórios e Indicadores
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between p-4 lg:pl-10">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          Painel administrador - Validação de Cupons
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between p-4 lg:pl-10 bg-slate-100">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          <div class="flex flex-col">
            Notificações Push
            <div class="text-slate-900 text-sm">
              Sua marca diretamente na tela do usuário
            </div>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="minus"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between p-4 lg:pl-10">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          <div class="flex flex-col">
            Branded Content
            <div class="text-slate-900 text-sm">
              Sua marca presente nos conteúdos do Mobo
            </div>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="minus"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between p-4 lg:pl-10 bg-slate-100">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          <div class="flex flex-col">
            Página exclusiva
            <div class="text-slate-900 text-sm">
              Seu restaurante com todas suas promoções em um só lugar
            </div>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between p-4 lg:pl-10">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">
          <div class="flex flex-col">
            Mobo Ads
            <div class="text-slate-900 text-sm">
              Sua promo impulsionada nas redes do Mobo
            </div>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="minus"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="minus"></ng-container>
          </div>
        </div>
        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div class="flex flex-col items-center justify-center">
            <ng-container *ngTemplateOutlet="check"></ng-container>
            <div
              class="text-success-500 text-xs font-medium leading-none tracking-tight"
            >
              1 / mês (individual)
            </div>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-between p-4 lg:pl-10 bg-slate-100">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">Suporte</div>

        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div
            class="text-slate-500 text-base font-normal leading-tight tracking-tight"
          >
            Central de ajuda +<br />Email
          </div>
        </div>

        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div
            class="text-slate-500 text-base font-normal leading-tight tracking-tight"
          >
            Central de ajuda +<br />Email + Consultor
          </div>
        </div>

        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div
            class="text-slate-500 text-base font-normal leading-tight tracking-tight"
          >
            Central de ajuda +<br />Email + Consultor
          </div>
        </div>
      </div>

      <div class="flex items-center justify-between p-4 lg:pl-10">
        <div class="shrink-0 basis-2/3 lg:basis-2/5 text-left">Onboarding</div>

        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div
            class="text-slate-500 text-base font-normal leading-tight tracking-tight"
          >
            Automatizado
          </div>
        </div>

        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div
            class="text-slate-500 text-base font-normal leading-tight tracking-tight"
          >
            Automatizado +<br />Assistência Consultor
          </div>
        </div>

        <div class="shrink-0 basis-1/2 lg:basis-1/5 text-center">
          <div
            class="text-slate-500 text-base font-normal leading-tight tracking-tight"
          >
            Automatizado +<br />Assistência Consultor
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #check>
  <div class="w-8 h-8 relative mx-auto">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M28.7081 9.70757L12.7081 25.7076C12.6152 25.8005 12.5049 25.8743 12.3835 25.9246C12.2621 25.975 12.132 26.0009 12.0006 26.0009C11.8691 26.0009 11.739 25.975 11.6176 25.9246C11.4962 25.8743 11.3859 25.8005 11.2931 25.7076L4.29306 18.7076C4.10542 18.5199 4 18.2654 4 18.0001C4 17.7347 4.10542 17.4802 4.29306 17.2926C4.4807 17.1049 4.73519 16.9995 5.00056 16.9995C5.26592 16.9995 5.52042 17.1049 5.70806 17.2926L12.0006 23.5863L27.2931 8.29257C27.4807 8.10493 27.7352 7.99951 28.0006 7.99951C28.2659 7.99951 28.5204 8.10493 28.7081 8.29257C28.8957 8.48021 29.0011 8.7347 29.0011 9.00007C29.0011 9.26543 28.8957 9.51993 28.7081 9.70757Z"
        fill="#1CC88A"
      />
    </svg>
  </div>
</ng-template>

<ng-template #minus>
  <div class="w-8 h-8 relative mx-auto">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M28 16C28 16.2652 27.8946 16.5196 27.7071 16.7071C27.5196 16.8946 27.2652 17 27 17H5C4.73478 17 4.48043 16.8946 4.29289 16.7071C4.10536 16.5196 4 16.2652 4 16C4 15.7348 4.10536 15.4804 4.29289 15.2929C4.48043 15.1054 4.73478 15 5 15H27C27.2652 15 27.5196 15.1054 27.7071 15.2929C27.8946 15.4804 28 15.7348 28 16Z"
        fill="#64748B"
      />
    </svg>
  </div>
</ng-template>
